export enum Permission {
  CustomersAndOrdersView = 'customers_and_orders.view',
  CareAdminUpdateName = 'care_admin.customers.details.update_name',
  CareAdminUpdatePhone = 'care_admin.customers.details.update_phone_number',
}
